import { Component, OnInit } from '@angular/core';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { GenericComponentControlService } from 'src/app/services/generic-component-control.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';

@Component({
  selector: 'app-generic-window',
  templateUrl: './generic-window.component.html',
  styleUrls: ['./generic-window.component.scss'],
  standalone: false
})
export class GenericWindowComponent implements OnInit {

  constructor(public genericController : GenericComponentControlService,
    private toolsService : ToolsControlService,
    public menuController : MenuManagementService) { }

  ngOnInit(): void {
  }

  cancelWindow():void{
    this.genericController.active = !this.genericController.active;
    this.toolsService.navigationOnTop = false;
  }
}
